import React from 'react';
import { Activity } from '@bingads-webui-react/hoc-with-signal';
import { useWizardService, getCurrentStepId } from '@bingads-webui-react/wizard';
import { ACTIVITY_NAME } from '../constants/logger';

export const withStepActivity = WrappedComponent => (props) => {
  const { state } = useWizardService();
  const currentStepId = getCurrentStepId(state);
  return (
    <Activity name={ACTIVITY_NAME[currentStepId]}>
      <WrappedComponent {...props} />
    </Activity>
  );
};
